import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import SearchIcon from '@atlaskit/icon/core/search';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

import { SquareReturnIcon } from '../../../../../common/constants/icons/square-return';
import { SearchLink } from '../../../../../common/ui/search-link';
import {
	type EventWithTarget,
	type SearchDropdownElementProps,
	SearchLinkTypes,
} from '../../../../../common/ui/search-link/types';
import { onDropdownResultClicked } from '../../../../../common/utils/events/dropdown-result-clicked';
import { useAnalytics, useCommonAndPrivateAttributes } from '../../../../../controllers/analytics';
import { useDropdownActions } from '../../../../../controllers/store/dropdown';
import { useInputQuery, useSearchActions } from '../../../../../controllers/store/search';

import { messages } from './messages';

const iconStyles = xcss({
	backgroundColor: 'color.background.neutral',
	borderRadius: 'radius.xsmall',
	width: '24px',
	height: '24px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});

const subheadingTextWrapper = xcss({
	marginRight: 'space.100',
});

export const MimicQuery = ({ getElementIndex }: SearchDropdownElementProps): React.JSX.Element => {
	const intl = useIntl();

	const [inputQuery] = useInputQuery();
	const { triggerSearch } = useSearchActions();
	const { setShowDropdown } = useDropdownActions();

	const { fireAnalyticsEvent } = useAnalytics();
	const { commonAttributes, nonPrivacySafeAttributes } = useCommonAndPrivateAttributes();

	const fireAnalytics = useCallback(
		(event: EventWithTarget) => {
			const index = event.target && getElementIndex ? getElementIndex(event.target) : undefined;

			fireAnalyticsEvent(
				onDropdownResultClicked({
					commonAttributes,
					nonPrivacySafeAttributes,
					resultType: SearchLinkTypes.MimicQuery,
					...(index !== undefined ? { index } : {}),
				}),
			);
		},
		[fireAnalyticsEvent, commonAttributes, nonPrivacySafeAttributes, getElementIndex],
	);

	return (
		<>
			{inputQuery.length > 0 && (
				<SearchLink
					title={inputQuery}
					subheading={
						<>
							<Box xcss={subheadingTextWrapper}>{intl.formatMessage(messages.search)}</Box>
							<SquareReturnIcon />
						</>
					}
					icon={
						<Box xcss={iconStyles}>
							<SearchIcon
								color="currentColor"
								label={intl.formatMessage(messages.searchIconLabel)}
							/>
						</Box>
					}
					onClick={(event) => {
						fireAnalytics(event);
						setShowDropdown(false);
						triggerSearch();
					}}
				/>
			)}
		</>
	);
};
